export type StackJeEnv = "staging" | "production" | "local";

export function getDomain(env?: StackJeEnv) {
  if (!env) {
    env = import.meta.env.PUBLISH_TO as StackJeEnv;
    if (!env) {
      env = import.meta.env.MODE as StackJeEnv;
    }
  }

  if (env === "production") {
    return "stack.je";
  }
  if (env === "staging") {
    return "5746713.xyz";
  }

  return "localhost";
}

export function getDomainPort(env?: StackJeEnv) {
  if (!env) {
    env = import.meta.env.MODE as StackJeEnv;
  }

  if (env === "production" || env === "staging") {
    return "";
  }
  return ":5173";
}

export function getSubdomain(request: Request | string, env: StackJeEnv) {
  let host =
    typeof request === "string" ? request : request.headers.get("host") || "";
  host = host.replace(/localhost(:\d+)?/, getDomain(env));
  const subdomain = host.split(".")[0];
  return subdomain;
}
